module.exports = __webpack_public_path__ + "media/newstyle/images/a4-white-47ddbc36a2a8251b61394d50ca39eaf5.svg";